import React from 'react';
import { EcoAssociation12Class2026 } from '../views';

const AccountGeneralPage = () => {
  return <EcoAssociation12Class2026/>;
};

export default AccountGeneralPage;